export default __webpack_public_path__ + "static/media/next.bafb92c9.svg";